import { useContext, useDebugValue } from "react";
import AuthContext from "../context/authProvider.context";

const useAuth = () => {
    const { auth , createUserAuth} = useContext(AuthContext);
    useDebugValue(auth, createUserAuth, auth => auth?.userId ? "Logged In" : "Logged Out")
    return useContext(AuthContext);
}

export default useAuth;